<template>
    <div class="dashboard">
        <loading ref="pLoadScreen"/>
        <header-navigation/>
        <div class="container">
            <oops ref="pOops"/>
            <error ref="pError"/>
            <platform-header ref="pHeader"/>
            <div class="platformDashContent">
                <platform-info ref="pInfo"/>
                <platform-vessels ref="pVessels"/>
            </div>
        </div>
        <bottom-credits/>
    </div>
</template>

<script>
import axios from 'axios';
import PlatformHeader from '../components/platforms/PlatformHeader.vue';
import PlatformInfo from '../components/platforms/PlatformInfo.vue';
import PlatformVessels from '../components/platforms/PlatformVessels.vue'
import Loading from '../components/Loading.vue';
import BottomCredits from '../components/BottomCredits.vue';
import HeaderNavigation from '../components/HeaderNavigation.vue';
import Oops from '../components/Oops.vue';
import Error from '../components/Error.vue';

export default {
    name: "Platforms",
    components: {
        PlatformHeader,
        PlatformInfo,
        PlatformVessels,
        Loading,
        BottomCredits,
        HeaderNavigation,
        Oops,
        Error
    },
    mounted() {
        var globv = this;
        globv.retrievePlatformData();
        globv.$refs.pLoadScreen.startLoading();
    },
    methods: {
        retrievePlatformData: async function() {
            var globv = this;
            let id = globv.$route.params.id;

            try {
                let response = await axios.get('/api/platforms/' + id);
                if (response && response.data) {
                    globv.updateComponentInfo(response.data);
                }
            }
            catch (error) {
                globv.handleError(error);
            }
        },
        updateComponentInfo: function(platformInfo) {
            let globv = this;
            console.log(JSON.stringify(platformInfo, undefined, 4));
            globv.$refs.pHeader.updateInfo(platformInfo);
            globv.$refs.pInfo.updateInfo(platformInfo);
            globv.$refs.pVessels.updateInfo(platformInfo['vessels']);

            setTimeout(globv.$refs.pLoadScreen.finishLoading, 300);
        },
        handleError: function(error) {
            var globv = this;
            console.log(error, error.response);
            error = error.response.data;
            if (error['error'] && error['error']['status'] < 500) {
                if (error['error']['status'] == 404)
                    globv.$refs.pError.showError({
                        status: 404, 
                        title: "Not Found", 
                        message: error['error']['message']
                    });
                else
                    globv.$refs.pError.showError({
                        status: error['error']['status'],
                        message: error['error']['message']
                    });
            }
            else
                globv.$refs.pOops.showOops();

            setTimeout(globv.$refs.pLoadScreen.finishLoading, 300);
        }
    }
}
</script>

<style lang="scss">
.platformDashContent {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1 0 auto;

    .chart {
        width: 400px;
    }
    
    > .card {
         width: 80%;
         max-width: 1200px;
    }

    .dashFlexContent {
        width: 80%;
    }
}

@media (max-width: 1200px) {
    .platformDashContent {
        width: 98vw;

        .card {
            margin: 20px 10px;
            width: 98%;
        }

        .dashFlexContent {
            width: 100%;
        }
    }
}

@media (max-width: 900px) {
    .platformDashContent {

        .card {
            margin: 20px 0px;
            width: 100%;
        }

        .dashFlexContent {
            flex-direction: column;
            align-items: center;

            .chart {
                width: 100%;
            }
        }
    }

    .infoVerticalSpacing {
        margin-top: 0;
    }
}

@media (max-width: 755px) {
    .platformDashContent {
        padding: 0;
        width: 100%;

        .dashFlexContent {
            .chart {
                width: 90vw;
            }
        }
    }
}

@media (max-width: 500px) {
    .platformDashContent {
        width: fit-content;

        .cardContent {
            padding: 0 10px 10px;
        }
    }
}

@media (max-width: 445px) {
    .platformDashContent p {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>